module.exports = __webpack_public_path__ + "static/media/discourse.6efb74b8.svg";